// Shared uniforms for the moving cloud shadows the terrain shader draws (TerrainTiles.tsx). One object, so
// AtmosphericClouds can drive every tile material without touching React state.

import { CLOUD_WIND } from './atmosphereClouds.js';

export const cloudShadowUniforms = {
  /** Seconds of drift (frozen under reduced motion). */
  uCloudTime: { value: 0 },
  /** 0 = off (setting off, perf guard tripped). */
  uCloudStrength: { value: 0 },
  /** 0..1 share of the ground in shadow. */
  uCloudCover: { value: 0.34 },
  uCloudWind: { value: CLOUD_WIND },
};

// Audit/debug hook (like window.__aod): lets a screenshot script force the shadows on.
if (typeof window !== 'undefined') {
  (window as unknown as { __cloudShadow?: typeof cloudShadowUniforms }).__cloudShadow =
    cloudShadowUniforms;
}

export const CLOUD_SHADOW_GLSL_PARS = /* glsl */ `
uniform float uCloudTime;
uniform float uCloudStrength;
uniform float uCloudCover;
uniform vec2 uCloudWind;
float _cloudHash(vec2 p) { return fract(sin(dot(p, vec2(127.1, 311.7))) * 43758.5453); }
float _cloudNoise(vec2 p) {
  vec2 i = floor(p);
  vec2 f = fract(p);
  vec2 u = f * f * (3.0 - 2.0 * f);
  return mix(mix(_cloudHash(i), _cloudHash(i + vec2(1.0, 0.0)), u.x),
             mix(_cloudHash(i + vec2(0.0, 1.0)), _cloudHash(i + vec2(1.0, 1.0)), u.x), u.y);
}
`;

/** Fragment snippet: darken the base colour where the drifting noise field is above the cover threshold. */
export const CLOUD_SHADOW_GLSL_MAIN = /* glsl */ `
if (uCloudStrength > 0.0) {
  // The offset keeps the board off the lattice origin, where the sine hash is 0 (no shadow at all).
  vec2 _cp = _vWorldPos.xz * 0.16 - uCloudWind * uCloudTime + vec2(37.2, 11.7);
  float _cn = 0.65 * _cloudNoise(_cp) + 0.35 * _cloudNoise(_cp * 2.3 + 7.0);
  // The noise sits around 0.5: map the cover share to a threshold so more cover = more ground in shadow.
  float _th = mix(0.74, 0.42, uCloudCover);
  float _cs = smoothstep(_th, _th + 0.2, _cn);
  diffuseColor.rgb *= 1.0 - uCloudStrength * _cs;
}
`;
